import React from "react";
import PropTypes from "prop-types";

import { propTypeChildren } from "@/utils";

import { StyledCard } from "./style";

function Card({ grayedOut, children, className }: any) {
  return (
    <StyledCard className={className} grayedOut={grayedOut}>
      {children}
    </StyledCard>
  );
}

Card.propTypes = {
  children: propTypeChildren,
};

Card.defaultProps = {};

export default Card;
